module.exports = __webpack_public_path__ + "img/der_01_stone.f6bbc8f9.png";